import React from "react"
import { render, cleanup, waitFor, act } from "@testing-library/react"

import Alert from "../index"

beforeEach(() => {
  jest.useFakeTimers()
})
afterEach(cleanup)

describe("<Alert />", () => {
  it("shows Alert as expected", async () => {
    const { queryByText } = render(<Alert message="hi there" isAlertOpen={true} />)

    await waitFor(() => expect(queryByText("hi there")).toBeInTheDocument())
  })

  it("does not show Alert as expected", async () => {
    const { queryByText } = render(<Alert message="yo" isAlertOpen={false} />)

    await waitFor(() => expect(queryByText("yo")).not.toBeInTheDocument())
  })

  it("fades out Alert expected", async () => {
    const { queryByText } = render(<Alert message="hi there" isAlertOpen={true} />)

    await waitFor(() => expect(queryByText("hi there")).toBeInTheDocument())

    // expect timeout to run
    expect(setTimeout).toHaveBeenLastCalledWith(expect.any(Function), 300)

    act(() => {
      // advance past timeout of timer and check that text isn't there
      jest.advanceTimersByTime(4000)
      expect(queryByText("hi there")).toBeNull()
    })
  })

  it("does not fade out Alert when when it's not open expected", async () => {
    const { queryByText } = render(<Alert message="yo" isAlertOpen={false} />)

    await waitFor(() => expect(queryByText("yo")).not.toBeInTheDocument())

    // make sure timeout is not run when no alert shown to begin with
    expect(setTimeout).not.toHaveBeenLastCalledWith(expect.any(Function), 300)
  })

  it("shows Alert when custom event fired", async () => {
    const { queryByText } = render(<Alert message="hi there" isAlertOpen={false} />)

    act(() => {
      // fire custom event while component is mounted but not open
      const customEvent = new CustomEvent("noticeChange", {
        detail: {
          isOpen: true,
          message: "Critical Function has been updated",
          iconName: "check-circle",
          color: "green"
        }
      })
      window.dispatchEvent(customEvent)
    })

    // check that initial message passed in doesn't exist but new message from the event is updated
    expect(queryByText("hi there")).not.toBeInTheDocument()
    expect(queryByText("Critical Function has been updated")).toBeInTheDocument()
  })
})
